import type { ApiRoute, NoPathParams, NoQueryParams, NoResponse } from "../api"
import type { TransferVehicleInput } from "../common"

export const offerTransferVehicleRoute: ApiRoute<NoPathParams, NoQueryParams, TransferVehicleInput, NoResponse> = {
	buildUrl: () => "/offers/transfer-vehicle",
	method: "post",
	path: "/offers/transfer-vehicle",
}
